import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Media } from '../_model/media';
import { NoticiasSend } from '../_model/Noticias';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

constructor(private http: HttpClient) { }

baseUrl: string = "https://"+environment.apiUrl+"/api/news/";

list() {
  return this.http.post(this.baseUrl+"list", null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}

get(id: number) {
  return this.http.post(this.baseUrl+"get/"+id, null).pipe(
    map((data: any) => {
      return data.result;
    })
  );
}

send(model: NoticiasSend) {
  return this.http.post(this.baseUrl+"input", model);
}

getMedia(id: number){
  return this.http.post(this.baseUrl+"media/"+id, null)
    .pipe(
      map((data: any) => {
        var result: Media[] = [];
        data.result.forEach(el => {
          result.push(new Media(el));
        });
        return result;
      })
    );
}
delete(id: number, userId: string) {
  return this.http.post(this.baseUrl+"delete/"+id,{id: userId}).pipe();
}

}
